export class Pep {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                export: false,
                table: false,
            },
            nombre_completo: {
                value: '',
                export: false,
                table: true,
                header: 'NOMBRE PEP:',
                required: 'Nombre del PEP es requerido',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 3 caracteres',
                max: 300,
                min: 3,
            },
            entidad_publica: {
                value: '',
                export: false,
                table: true,
                header: 'INSTITUCION:',
                required: 'Institución es requerida',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 3 caracteres',
                max: 200,
                min: 3,
            },
            cargo_publico: {
                value: '',
                export: false,
                table: true,
                header: 'CARGO:',
                required: 'Cargo es requerida',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 3 caracteres',
                max: 200,
                min: 3,
            },
            parentesco: {
                value: '',
                export: false,
                table: true,
                header: 'PARENTESCO/RELACIÓN:',
                required: 'Parentesco/Relación es requerida',
                maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 3 caracteres',
                max: 200,
                min: 3,
            },
        }
    }

    optionLabel = 'nombre';
}
